// 设备管理
const waterControllerJurisdiction = [
  { id: "027002001", label: "添加", children: [] },
  { id: "027002003", label: "修改", children: [] },
  { id: "027002002", label: "删除", children: [] }
];

// 水表管理
const waterAmmeterJurisdiction = [
  { id: "027002005", label: "添加", children: [] },
  { id: "027002006", label: "删除", children: [] },
  { id: "027002007", label: "修改", children: [] },
  { id: "027002008", label: "查看历史水量", children: [] },
  { id: "027002009", label: "导入水表", children: [] },
  { id: "027002010", label: "导出水表", children: [] }
];

// 水量监测
const waterMonitoringJurisdiction = [
  { id: "027012001", label: "导出", children: [] }
];

// 收费配置
const waterConfigJurisdiction = [
  { id: "027003001", label: "修改", children: [] }
];

// 场景配置
const waterSceneConfigJurisdiction = [
  { id: "027004001", label: "添加", children: [] },
  { id: "027004002", label: "删除", children: [] }
];

//结算配置
const waterConfigSettleJurisdiction = [
  { id: "027004006", label: "保存", children: [] }
];

//按水表统计
const waterQuantityJurisdiction = [
  { id: "027005001", label: "导出", children: [] }
];
//设备状态日志
const waterControllerDeviceStatusLogJurisdiction = [
  { id: "027010001", label: "导出", children: [] }
];

// 智慧用水
const waterServiceJurisdictionChildren = [
  {
    id: "027001000",
    label: "概览",
    routerName: "water-over-view",
    children: []
  },
  {
    id: "027002000",
    label: "集中器管理",
    routerName: "water-controller-management",
    children: waterControllerJurisdiction
  },
  {
    id: "027002004",
    label: "水表管理",
    routerName: "water-ammeter-management",
    children: waterAmmeterJurisdiction
  },
  {
    id: "027003000",
    label: "收费配置",
    routerName: "water-config-center",
    children: waterConfigJurisdiction
  },
  {
    id: "027004000",
    label: "场景配置",
    routerName: "water-device-scene-config",
    children: waterSceneConfigJurisdiction
  },
  {
    id: "027004005",
    label: "结算配置",
    routerName: "water-config-settle",
    children: waterConfigSettleJurisdiction
  },
  {
    id: "027005000",
    label: "按水表统计",
    routerName: "water-quantity",
    children: waterQuantityJurisdiction
  },
  {
    id: "027006000",
    label: "按住户统计",
    routerName: "water-quantity-public",
    children: []
  },
  {
    id: "027012000",
    label: "水表读数",
    routerName: "water-monitoring",
    children: waterMonitoringJurisdiction
  },
  {
    id: "027007000",
    label: "余额管理",
    routerName: "water-rent-money",
    children: []
  },
  {
    id: "027008000",
    label: "充值记录",
    routerName: "water-pay-record",
    children: []
  },
  {
    id: "027009000",
    label: "结算记录",
    routerName: "water-settlement-record",
    children: []
  },
  {
    id: "027010000",
    label: "设备状态日志",
    routerName: "water-controller-device-status-log",
    children: waterControllerDeviceStatusLogJurisdiction
  },
  {
    id: "027011000",
    label: "操作日志",
    routerName: "water-control-log",
    children: []
  }
];

const waterServiceJurisdiction = {
  id: "027",
  label: "智慧用水",
  children: waterServiceJurisdictionChildren
};

export { waterServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/waterServiceJurisdiction.js